<template>
  <div>
    <div class=" text-center">
      Create Customer
    </div>

    <div v-if="step === 1">
      <div>
        <h3 class="text-center fw-bold text-primary">Step One</h3>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-7">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Account Type</label>
                <select name="" id="" v-model="type" class="form-control">
                  <option value="" disabled selected
                    >Please Account Type</option
                  >
                  <option value="new">New</option>
                  <option value="existing">Existing</option></select
                >
              </div>
            </div>
            <div v-if="type === 'existing'" class="col-md-12">
              <div class="form-group">
                <label for="bvn">BVN</label>
                <input
                  type="text"
                  class="form-control"
                  @keypress="isNumber($event)"
                  maxlength="11"
                  v-model="bvn"
                  placeholder="12345678901"
                />
              </div>
            </div>
            <div v-if="type === 'existing'" class="col-md-12">
              <div class="form-group">
                <label for="bvn">Account Number</label>
                <input
                  type="text"
                  v-model="account_number"
                  @keypress="isNumber($event)"
                  maxlength="10"
                  class="form-control"
                  placeholder="1234567890"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class=" form-group">
                <label for="">Phone Number</label>
                <input
                  type="text"
                  class=" form-control"
                  @keypress="isNumber($event)"
                  placeholder="08012345678"
                  v-model="phone_number"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Email</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="email"
                  placeholder="Customeremail@gmail.com"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Username</label>
                <input
                  type="text"
                  placeholder="Customer's Username"
                  class=" form-control"
                  v-model="username"
                />
              </div>
            </div>
          </div>
          <div class=" row justify-content-end">
            <div class="col-5">
              <button
                type="button"
                class="btn btn-primary w-100"
                @click.prevent="stepOneFunction"
                :disabled="!stepOneFormIsValid || stepOneLoading"
              >
                <span class="custom-loader" v-if="stepOneLoading">
                  <loader-icon size="1.5x" class="custom-class"></loader-icon>
                  <span style="font-weight: 600; text-transform: initial;"
                    >Please wait...</span
                  >
                </span>
                <span v-else>
                  Proceed
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="step === 2 && dataInfo !== null">
      <div>
        <h3 class="text-center fw-bold text-primary">Step Two</h3>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-7">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Gender</label>
                <select
                  name=""
                  id=""
                  v-model="dataInfo.gender"
                  class="form-control"
                >
                  <option
                    :value="null || ''"
                    :disabled="
                      dataInfo.gender === null || dataInfo.gender === ''
                    "
                    selected
                    >Please Select Gender</option
                  >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label for="">Address</label>
                <textarea
                  name=""
                  class="form-control"
                  id=""
                  placeholder="Customer's Address"
                  cols="30"
                  rows="4"
                  v-model="dataInfo.address"
                  style="resize: none"
                ></textarea>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="city">City</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.city"
                  placeholder="City's Name"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="state">State</label>
                <select
                  name="state"
                  v-model="dataInfo.state_id"
                  class="form-control"
                >
                  <option value selected disabled>Select state</option>
                  <option
                    :value="state.id"
                    v-for="state in states"
                    :key="state.id"
                    >{{ state.name }}</option
                  >
                </select>
              </div>
            </div>

            <div class=" col-md-12">
              <div class="form-group">
                <label for="">Date Of Birth</label>
                <input
                  type="date"
                  v-model="dataInfo.date_of_birth"
                  placeholder="12/09/2009"
                  class="form-control"
                />
              </div>
            </div>
          </div>

          <div class="row justify-content-between">
            <div class="col-5">
              <button @click.prevent="goBack" class="btn btn-danger">
                Go Back
              </button>
            </div>
            <div class="col-5">
              <button
                @click.prevent="stepTwoFunction"
                class="btn btn-primary w-100"
                :disabled="stepTwoLoading || !stepTwoFormIsValid"
              >
                <span class="custom-loader" v-if="stepTwoLoading">
                  <loader-icon size="1.5x" class="custom-class"></loader-icon>
                  <span style="font-weight: 600; text-transform: initial;"
                    >Please Wait...</span
                  >
                </span>
                <span v-else>
                  Proceed
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="step === 3 && dataInfo !== null">
      <div>
        <h3 class="text-center fw-bold text-primary">Step Three</h3>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-7">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Mode Of Accounting Opening</label>
                <select
                  name=""
                  id=""
                  v-model="account_opening_mode"
                  class=" form-control"
                >
                  <option value="" disabled selected>Please Select Mode</option>
                  <option value="bvn">BVN</option>
                  <option value="existing_bank_account"
                    >Existing Account Number</option
                  >
                </select>
              </div>
            </div>

            <div class="col-md-12" v-if="account_opening_mode === 'bvn'">
              <div class="form-group">
                <label for="">
                  BVN
                </label>
                <input
                  type="text"
                  maxlength="11"
                  @keypress="isNumber($event)"
                  class="form-control"
                  v-model="bvn"
                />
              </div>
            </div>

            <div
              class="col-md-12"
              v-if="account_opening_mode === 'existing_bank_account'"
            >
              <div class="form-group">
                <label for="">Banks</label>

                <select
                  name=""
                  id=""
                  v-model="bank_id"
                  :disabled="bankLoading"
                  class="form-control"
                >
                  <option value="" :selected="bankLoading">
                    {{ bankLoading ? "Please Wait..." : "Choose Bank" }}
                  </option>
                  <option
                    :value="item.id"
                    v-for="(item, index) in banks"
                    :key="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="col-md-12"
              v-if="account_opening_mode === 'existing_bank_account'"
            >
              <div class="form-group">
                <label for="">Account Number</label>
                <input
                  type="text"
                  @keypress="isNumber($event)"
                  maxlength="10"
                  class="form-control"
                  placeholder="1000233455"
                  v-model="account_number"
                />
              </div>
            </div>
          </div>

          <div class="row justify-content-between">
            <div class="col-5">
              <button @click.prevent="goBack" class="btn btn-danger">
                Go Back
              </button>
            </div>
            <div class="col-5">
              <button
                @click.prevent="stepThreeFunction"
                class="btn btn-primary w-100"
                :disabled="stepThreeLoading || !stepThreeFormIsValid"
              >
                <span class="custom-loader" v-if="stepThreeLoading">
                  <loader-icon size="1.5x" class="custom-class"></loader-icon>
                  <span style="font-weight: 600; text-transform: initial;"
                    >Please Wait...</span
                  >
                </span>
                <span v-else>
                  Proceed
                </span>
              </button>
            </div>
          </div>

          <div
            class=" bg-success p-2  mt-2 rounded-1"
            v-if="stepThreeMessage !== ''"
          >
            <h3 class=" text-white text-capitalize text-center ">
              {{ stepThreeMessage }}
            </h3>
          </div>

          <div
            v-if="dataInfo.bvn_image !== null"
            style="display: flex; justify-content: center;"
          >
            <img
              :src="dataInfo.bvn_image"
              style="width: 300px; height: 400px;"
              alt=""
              class=" img-fluid"
            />
          </div>

          <div class="row justify-content-center mt-2">
            <div class="col-6" v-if="showStepFourButton">
              <button @click="step = 4" class="btn btn-blue-grey">
                Finalize Onboarding
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="step === 4 && dataInfo !== null">
      <div>
        <h3 class="text-center fw-bold text-primary">Final Stage</h3>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-7">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="">Username</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.username"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">First Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.first_name"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">Last Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.last_name"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">Email</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.email"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">Gender</label>

                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.gender"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">Phone Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.phone_number"
                  disabled
                />
              </div>
            </div>

            <div class="col-12">
              <div class="form-group">
                <label for="">Address</label>
                <textarea
                  name=""
                  id=""
                  cols="30"
                  rows="4"
                  disabled
                  class="form-control"
                  v-model="dataInfo.address"
                ></textarea>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">City</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.city"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">State</label>
                <select
                  name="state"
                  v-model="dataInfo.state_id"
                  class="form-control"
                  disabled
                >
                  <option value="" selected disabled>Select state</option>
                  <option
                    :value="state.id"
                    v-for="state in states"
                    :key="state.id"
                    >{{ state.name }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">BVN</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.bvn"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">BVN Status</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="dataInfo.bvn_status"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="row justify-content-between">
            <div class="col-5">
              <button @click.prevent="goBack" class="btn btn-danger w-100">
                Go Back
              </button>
            </div>
            <div class="col-6">
              <button
                @click.prevent="finalizeFunction"
                class="btn btn-primary w-100"
              >
                <span class="custom-loader" v-if="fLoading">
                  <loader-icon size="1.5x" class="custom-class"></loader-icon>
                  <span style="font-weight: 600; text-transform: initial;"
                    >Please Wait...</span
                  >
                </span>
                <span v-else>
                  Proceed
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
export default {
  name: "CreateCustomer",
  data() {
    return {
      account_opening_mode: "",
      step: 1,
      type: "",
      phone_number: "",
      email: "",
      stepOneLoading: false,
      stepTwoLoading: false,
      stepThreeLoading: false,
      username: "",
      bvn: "",
      account_number: "",
      dataInfo: null,
      states: [],
      banks: [],
      bankLoading: false,
      bank_id: "",
      stepThreeMessage: "",
      bvnImage: "",
      showStepFourButton: false,
      fLoading: false
    };
  },
  computed: {
    stepOneFormIsValid() {
      if (this.type !== "" && this.phone_number !== " " && this.email !== "") {
        if (this.type === "existing") {
          return this.bvn !== "" && this.account_number !== "";
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    stepTwoFormIsValid() {
      if (
        this.dataInfo.gender !== null &&
        this.dataInfo.address !== null &&
        this.dataInfo.city !== null &&
        this.dataInfo.state_id !== null &&
        this.dataInfo.date_of_birth !== null
      ) {
        return (
          this.dataInfo.gender !== "" &&
          this.dataInfo.address !== "" &&
          this.dataInfo.city !== "" &&
          this.dataInfo.state_id !== "" &&
          this.dataInfo.date_of_birth !== ""
        );
      } else {
        return false;
      }
    },
    stepThreeFormIsValid() {
      if (this.account_opening_mode !== "") {
        if (this.account_opening_mode === "bvn") {
          return this.bvn !== "";
        } else if (this.account_opening_mode === "existing_bank_account") {
          return this.account_number !== "" && this.bank_id !== "";
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    async goBack() {
      if (this.step === 2) {
        this.step = 1;
        return;
      }
      if (this.step === 4 && this.type === "existing") {
        this.step = 2;
        return;
      } else {
        this.step = this.step - 1;
        return;
      }
    },
    async getBanks() {
      try {
        console.log("inside");
        this.bankLoading = true;
        let response = await ApiService.get("transfer/banks");
        this.banks = response.data.data;
        this.bankLoading = false;
      } catch (error) {
        console.log(error);
        this.bankLoading = false;
      }
    },
    async getStates() {
      try {
        const response = await ApiService.get("utility/state-list");
        this.states = response.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    generatePassword() {
      const specialChars = "!@#$%^&*()_+-=[]{}|;:,.<>?";
      const uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
      const numberChars = "0123456789";

      let password = "";

      // add at least one of each required character type
      password += this.getRandomChar(specialChars);
      password += this.getRandomChar(uppercaseChars);
      password += this.getRandomChar(lowercaseChars);
      password += this.getRandomChar(numberChars);

      // add remaining characters randomly
      for (let i = 4; i < 8; i++) {
        const charTypes = [
          specialChars,
          uppercaseChars,
          lowercaseChars,
          numberChars
        ];
        const randomType =
          charTypes[Math.floor(Math.random() * charTypes.length)];
        password += this.getRandomChar(randomType);
      }

      return password;
    },
    getRandomChar(characters) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      return characters.charAt(randomIndex);
    },
    async stepOneFunction() {
      let data = {
        email: this.email,
        phone_number: this.phone_number,
        password: this.generatePassword(),
        username: this.username,
        bvn: this.bvn,
        type: this.type,
        account_number: this.account_number
      };

      try {
        this.stepOneLoading = true;
        let response = await ApiService.post(
          data.type === "new"
            ? "onboarding/step-one"
            : "onboarding/step-one-existing",
          data
        );

        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.dataInfo = response.data.data;
        this.step = 2;
        this.stepOneLoading = false;
      } catch (error) {
        let _error = error.response.data;
        this.stepOneLoading = false;

        ErrorService.displayErrorAlert(_error);
        console.log(_error);
      }
    },
    async stepTwoFunction() {
      let data = {
        hash: this.dataInfo.hash,
        gender: this.dataInfo.gender,
        address: this.dataInfo.address,
        city: this.dataInfo.city,
        state_id: this.dataInfo.state_id,
        date_of_birth: this.dataInfo.date_of_birth
      };
      try {
        this.stepTwoLoading = true;
        const response = await ApiService.post("onboarding/step-two", data);
        this.dataInfo = response.data.data;
        this.step =
          this.dataInfo.account_type === "new"
            ? 3
            : this.dataInfo.account_type === "existing"
            ? 4
            : 1;

        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.stepTwoLoading = false;
      } catch (error) {
        this.stepTwoLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        console.log(_error);
      }
    },
    async stepThreeFunction() {
      this.stepThreeLoading = true;

      let data = {
        hash: this.dataInfo.hash,
        bank_id: this.bank_id,
        account_number: this.account_number,
        type: "onboarding",
        bypass: "yes",
        bvn: this.bvn
      };
      try {
        const response = await ApiService.post(
          this.account_opening_mode === "bvn"
            ? "bvn/check"
            : "onboarding/account-number-verification",
          data
        );

        this.dataInfo = response.data.data;

        this.stepThreeMessage = response.data.message;
        this.stepThreeLoading = false;
        this.showStepFourButton = true;
      } catch (error) {
        this.stepThreeLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        console.log(_error);
      }
    },
    async finalizeFunction() {
      this.fLoading = true;
      let data = {
        hash: this.dataInfo.hash,
        pin: Math.floor(Math.random() * 9000) + 1000
      };
      console.log(data);
      try {
        const response = await ApiService.post("onboarding/step-six", data);
        this.dataInfo = response.data.data;
        this.fLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(
          () =>
            this.$router.push({
              name: "CustomerComponent",
              params: {
                slug: this.dataInfo.user_id
              }
            }),
          3000
        );
      } catch (error) {
        this.fLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        console.log(_error);
      }
    }
  },
  mounted() {
    this.getStates();
    this.getBanks();
  }
};
</script>

<style scoped></style>
